// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logo_logoContainer__3YZnM","root":"logo_root__p98_e"};